module.exports = __webpack_public_path__ + "static/media/sign-out.86318705.svg";